import { Box, Popover, SelectorButton, Tag, Text } from '@wix/design-system';
import { ChevronDown } from '@wix/wix-ui-icons-common/lazy';
import clsx from 'clsx';
import React, { useState } from 'react';
import sharedStyles from '../../layouts/SharedStyles.scss';
import tldSelectorStyles from './TagDropdown.scss';
export const TagDropdown = _ref => {
  let value = _ref.value,
    options = _ref.options,
    maxSelections = _ref.maxSelections,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange;
  const _useState = useState(false),
    isOpen = _useState[0],
    setIsOpen = _useState[1];
  const toggle = () => setIsOpen(prev => !prev);
  const handleClick = clickedTag => {
    const isSelected = value.includes(clickedTag);
    let newTags;
    if (isSelected) {
      newTags = value.filter(tag => tag !== clickedTag);
    } else {
      if (typeof maxSelections === 'undefined' || value.length < maxSelections) {
        newTags = [...value, clickedTag];
      } else {
        newTags = [...value.slice(0, -1), clickedTag];
      }
    }
    onChange == null || onChange(newTags);
  };
  return /*#__PURE__*/React.createElement(Popover, {
    showArrow: false,
    placement: "bottom-start",
    moveBy: {
      x: 0,
      y: 0
    },
    shown: isOpen,
    onClickOutside: () => setIsOpen(false),
    className: clsx(sharedStyles.dropdownContainer, {
      [sharedStyles.opened]: isOpen
    }),
    appendTo: "viewport",
    fixed: true,
    animate: true
  }, /*#__PURE__*/React.createElement(Popover.Element, null, /*#__PURE__*/React.createElement(SelectorButton, {
    fullWidth: fullWidth,
    onClick: toggle,
    suffixIcon: /*#__PURE__*/React.createElement(ChevronDown, null),
    size: "small"
  }, placeholder && /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, value.length > 0 ? `${placeholder} (${value.length})` : placeholder))), /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(Box, {
    flexWrap: "wrap",
    gap: "SP3",
    padding: "SP2",
    overflow: "auto",
    width: "272px"
  }, options.map(tag => {
    const isSelected = value.includes(tag.id);
    return /*#__PURE__*/React.createElement(Tag, {
      skin: "lightOutlined",
      key: JSON.stringify(tag),
      id: tag.id,
      removable: false,
      onClick: () => handleClick(tag.id),
      className: clsx(tldSelectorStyles.dropdownTag, {
        [tldSelectorStyles.selected]: isSelected
      })
    }, /*#__PURE__*/React.createElement(Text, {
      size: "tiny"
    }, tag.value));
  }))));
};
//# sourceMappingURL=TagDropdown.js.map